import { Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import { useEffect, useRef } from 'react';

interface Props {
  children?: React.ReactNode;
  scrollMarginTop?: keyof typeof vars.space | 'none';
}

export function ScrollOnMount({
  children = <span />,
  scrollMarginTop = 'xxlarge',
}: Props) {
  const { scrollIntoView, ScrollTarget } = useSmoothScroll({
    scrollMarginTop,
  });

  useEffect(() => {
    scrollIntoView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ScrollTarget>{children}</ScrollTarget>;
}

interface Options {
  scrollMarginTop: Props['scrollMarginTop'];
}

export const useSmoothScroll = (options?: Options) => {
  const scrollMarginTop = options?.scrollMarginTop || 'xxlarge';
  const ref = useRef<HTMLDivElement>(null);

  const scrollIntoView = () => {
    ref.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  };

  const ScrollTarget = ({ children }: { children: React.ReactNode }) => (
    <Box
      ref={ref}
      style={{
        scrollMarginTop:
          scrollMarginTop === 'none' ? 0 : vars.space[scrollMarginTop],
      }}
    >
      {children}
    </Box>
  );

  return { ref, scrollIntoView, ScrollTarget };
};
